// Generated by scripts/align_sonatas.ts. Do not edit by hand.
import type { SonataFile } from './types';
import s0 from './json/k279-1.json';
import s1 from './json/k279-2.json';
import s2 from './json/k279-3.json';
import s3 from './json/k280-1.json';
import s4 from './json/k280-2.json';
import s5 from './json/k280-3.json';
import s6 from './json/k281-1.json';
import s7 from './json/k281-2.json';
import s8 from './json/k281-3.json';
import s9 from './json/k282-1.json';
import s10 from './json/k282-2.json';
import s11 from './json/k282-3.json';
import s12 from './json/k283-1.json';
import s13 from './json/k283-2.json';
import s14 from './json/k283-3.json';
import s15 from './json/k284-1.json';
import s16 from './json/k284-2.json';
import s17 from './json/k284-3.json';
import s18 from './json/k309-1.json';
import s19 from './json/k309-2.json';
import s20 from './json/k309-3.json';
import s21 from './json/k310-1.json';
import s22 from './json/k310-2.json';
import s23 from './json/k310-3.json';
import s24 from './json/k311-1.json';
import s25 from './json/k311-2.json';
import s26 from './json/k311-3.json';
import s27 from './json/k330-1.json';
import s28 from './json/k330-2.json';
import s29 from './json/k330-3.json';
import s30 from './json/k331-1.json';
import s31 from './json/k331-2.json';
import s32 from './json/k331-3.json';
import s33 from './json/k332-1.json';
import s34 from './json/k332-2.json';
import s35 from './json/k332-3.json';
import s36 from './json/k333-1.json';
import s37 from './json/k333-2.json';
import s38 from './json/k333-3.json';
import s39 from './json/k457-1.json';
import s40 from './json/k457-2.json';
import s41 from './json/k457-3.json';
import s42 from './json/k533-1.json';
import s43 from './json/k533-2.json';
import s44 from './json/k533-3.json';
import s45 from './json/k545-1.json';
import s46 from './json/k545-2.json';
import s47 from './json/k545-3.json';
import s48 from './json/k570-1.json';
import s49 from './json/k570-2.json';
import s50 from './json/k570-3.json';
import s51 from './json/k576-1.json';
import s52 from './json/k576-2.json';
import s53 from './json/k576-3.json';

/** Sonata movements that passed the alignment gate, in Köchel order (compact; decode with ../chorales/codec.ts). */
export const SONATA_FILES = [s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17, s18, s19, s20, s21, s22, s23, s24, s25, s26, s27, s28, s29, s30, s31, s32, s33, s34, s35, s36, s37, s38, s39, s40, s41, s42, s43, s44, s45, s46, s47, s48, s49, s50, s51, s52, s53] as unknown as SonataFile[];
